import React from 'react';

export default function Lock() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 5.5C6 6 6.0625 6.4375 6.1875 6.875C6.25 7.0625 6.21875 7.25 6.0625 7.375L1 12.4688V15H4V13.5C4 13.25 4.21875 13 4.5 13H6V11.5C6 11.25 6.21875 11 6.5 11H8.03125L9 10.0312C9.125 9.90625 9.3125 9.875 9.46875 9.90625C9.8125 9.96875 10.125 10 10.5 10C12.9688 10 15 8 15 5.5C15 3.03125 12.9688 1 10.5 1C8 1 6 3.03125 6 5.5ZM10.5 0C13.5312 0 16 2.46875 16 5.5C16 8.5625 13.5312 11 10.5 11C10.1562 11 9.84375 11 9.53125 10.9375L8.59375 11.875C8.5 11.9688 8.375 12 8.25 12H7V13.5C7 13.7812 6.75 14 6.5 14H5V15.5C5 15.7812 4.75 16 4.5 16H0.5C0.21875 16 0 15.7812 0 15.5V12.25C0 12.125 0.03125 12 0.125 11.9062L5.15625 6.875C5.03125 6.4375 5 6 5 5.5C5 2.46875 7.4375 0 10.5 0ZM11.5 5.25C11.0625 5.25 10.75 4.9375 10.75 4.5C10.75 4.09375 11.0625 3.75 11.5 3.75C11.9062 3.75 12.25 4.09375 12.25 4.5C12.25 4.9375 11.9062 5.25 11.5 5.25Z"
        fill="currentColor"
      />
    </svg>
  );
}
